import { Injector } from "@angular/core";
import { AutoUploadNode } from "../../AutoUploadNode";
import { AutoUploadEntityEnum } from "../../../AutoUploadEntityEnum";
import { ServiceEnum } from "../../../ServiceEnum";
import { SponsorEntity } from "../../../Data/MedicinalProductData/SponsorEntity";
import { BaseNode } from "../../BaseNode";
import { TreeNodeOrganisationList } from "../../Art57Node/ListEntity/TreeNodeOrganisationList";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { environment } from "../../../../../../environments/environment";

export class SponsorAutoUploadEntity extends AutoUploadNode {
    useHist: boolean = false;
    constructor(injector: Injector, labelTemplate: string, parent: BaseNode, model: any, useHist: boolean, disableAutoUpload: boolean, cloningNode: boolean){
        const createChildTemplateparams = {nodeType:2};
        super (injector, labelTemplate, SponsorEntity, useHist ? AutoUploadEntityEnum.sponsorHist: AutoUploadEntityEnum.sponsor, ServiceEnum.MedicinalProducts, parent, model,TreeNodeOrganisationList, false, disableAutoUpload, cloningNode, createChildTemplateparams);
        this.labelNodeName = 'Sponsor';
        this.useHist = useHist;
      }

    override cloneNode(newParent: BaseNode): BaseNode {
      let clonedNode: SponsorAutoUploadEntity = new SponsorAutoUploadEntity(this.ioc!, this.label!, newParent, this.data.model, this.useHist, this.isLoaded, true);      
      
      clonedNode.loadEntity();
      clonedNode.isLoading = false;

      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

      clonedNode.cloningNode = false;
      return clonedNode;

    }
    
}